export default "__VITE_ASSET__27b9724e__"